var parts = ['card', 'icon', 'button', 'header', 'content', 'body', 'footer'];
var defaultPadding = {
  base: 4,
  md: 6
};
var baseStyle = function baseStyle(props) {
  var isElevated = props.isElevated;
  return {
    card: {
      layerStyle: 'card',
      p: defaultPadding,
      overflowWrap: 'break-word',
      boxShadow: isElevated ? 'md' : 'sm',
      flexDirection: {
        base: 'column',
        sm: 'row'
      },
      justifyContent: 'flex-start',
      position: 'relative'
    },
    icon: {
      boxSize: 6,
      mr: 4,
      d: {
        base: 'none',
        sm: 'block'
      }
    },
    button: {
      fontSize: '1.5rem',
      p: 2.5,
      mt: {
        base: 4,
        sm: '0'
      },
      alignSelf: {
        base: 'inherit',
        sm: 'flex-start'
      },
      justifyContent: 'center'
    },
    content: {
      mr: {
        base: '',
        sm: 'auto'
      }
    },
    header: {
      textAlign: {
        base: 'center',
        sm: 'inherit'
      }
    },
    body: {
      textStyle: 'text',
      pt: 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: {
        base: 'center',
        sm: 'inherit'
      }
    },
    footer: {
      pt: 2,
      textStyle: 'text',
      textAlign: {
        base: 'center',
        sm: 'inherit'
      }
    }
  };
};
function variantDownload(props) {
  var isDownloaded = props.isDownloaded;
  return {
    header: {
      textStyle: 'heading',
      fontSize: 'xl'
    },
    icon: {
      boxSize: 8,
      bg: isDownloaded ? 'green.400' : 'yellow.300',
      color: 'white',
      borderRadius: 'base',
      p: 1.5,
      alignSelf: {
        base: 'inherit',
        sm: 'flex-start'
      },
      justifyContent: 'center'
    }
  };
}
function variantInformation() {
  return {
    header: {
      textStyle: 'text',
      color: 'gray.400'
    },
    body: {
      textStyle: 'heading',
      fontSize: 'md'
    }
  };
}
var variants = {
  download: variantDownload,
  information: variantInformation
};
var ColumnCard = {
  parts: parts,
  variants: variants,
  baseStyle: baseStyle
};
export { ColumnCard as default };